// FULL 1:1 CONVERSION – MealFlow24.jsx
// Mobile-first, Tailwind, FontAwesome, Chart.js

import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from "chart.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faStar } from '@fortawesome/free-solid-svg-icons';

ChartJS.register(CategoryScale, LinearScale, BarElement);

const StarRating = ({ value, onChange }) => {
  return (
    <div className="flex gap-1">
      {[...Array(10)].map((_, i) => {
        const val = (i + 1) * 0.5;
        return (
          <i
            key={i}
            onClick={() => onChange(val)}
            className={`w-10 lg:w-12 fa-star cursor-pointer ${value >= val ? "fas text-yellow-400" : "far"}`}
          ></i>
        );
      })}
    </div>
  );
};

const getDeliveryBatchData = () => ([
  {
    slot: "06-07",
    jobs: [
      { id: "D201", kitchen: "Kitchen A", orders: 3 },
      { id: "D202", kitchen: "Kitchen B", orders: 5 },
      { id: "D203", kitchen: "Kitchen C", orders: 2 },
    ],
  },
  {
    slot: "07-08",
    jobs: [
      { id: "D204", kitchen: "Kitchen A", orders: 4 },
      { id: "D205", kitchen: "Kitchen D", orders: 3 },
    ],
  },
  {
    slot: "08-09",
    jobs: [
      { id: "D206", kitchen: "Kitchen B", orders: 6 },
      { id: "D207", kitchen: "Kitchen C", orders: 2 },
    ],
  },
  {
    slot: "12-13",
    jobs: [
      { id: "D208", kitchen: "Kitchen E", orders: 5 },
      { id: "D209", kitchen: "Kitchen F", orders: 3 },
    ],
  },
  {
    slot: "19-20",
    jobs: [
      { id: "D210", kitchen: "Kitchen A", orders: 7 },
      { id: "D211", kitchen: "Kitchen G", orders: 4 },
    ],
  },
]);
const deliveryData = getDeliveryBatchData();


export default function MealFlow24Home() {
  const [tab, setTab] = useState("customer");
  const [role, setRole] = useState("customer");
  const [packing, setPacking] = useState("casserole");
  const [deliveryMode, setDeliveryMode] = useState("home");
  const [fpVerified, setFpVerified] = useState(false);
  const [dpVerified, setDpVerified] = useState(false);
  const [rating1, setRating1] = useState(0);
  const [rating2, setRating2] = useState(0);

  const Tab = (id, label) => (
    <button
      onClick={() => setTab(id)}
      className={`p-2 text-xs ${tab === id ? "bg-green-600 text-white" : "bg-blue-600"}`}
    >
      {label}
    </button>
  );

  const chartData = {
    labels: [
        "00-01","01-02","02-03","03-04","04-05",
        "05-06","06-07","07-08","08-09","09-10",
        "10-11","11-12","12-13","13-14","14-15",
        "15-16","16-17","17-18","18-19","19-20",
        "20-21","21-22","22-23","23-24"
    ],
    datasets: [
        {
        label: "Orders",
        data: [
            2,1,1,1,2,
            5,25,40,32,20,
            15,18,35,28,22,
            18,20,30,45,50,
            38,22,10,5
        ],
        },
        {
        label: "Batches",
        data: [
            1,1,1,1,1,
            2,5,7,6,4,
            3,3,6,5,4,
            3,4,6,8,9,
            7,5,2,1
        ],
        }
    ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: "top" },
        },
        scales: {
            y: {
            beginAtZero: true,
            },
        },
    };

    const [selectedOrder, setSelectedOrder] = useState(null);

    const ordersData = [
        {
            slot: "06-07",
            items: [
            { id: "#101", date: "26 Apr", customer: "Rahul", meal: "Breakfast", qty: 10, amt: 1200, address: "Colaba", phone: "9999999999", instruction: "Less oil", status: "Order Placed" },
            { id: "#102", date: "26 Apr", customer: "Amit", meal: "Breakfast", qty: 6, amt: 720, address: "Colaba", phone: "8888888888", instruction: "No onion", status: "Preparing" },
            ],
        },
        {
            slot: "07-08",
            items: [
            { id: "#103", date: "26 Apr", customer: "Neha", meal: "Breakfast", qty: 12, amt: 1440, address: "Bandra", phone: "7777777777", instruction: "", status: "Order Placed" },
            ],
        },
        {
            slot: "12-13",
            items: [
            { id: "#104", date: "26 Apr", customer: "Sanjay", meal: "Lunch", qty: 20, amt: 3000, address: "Andheri", phone: "6666666666", instruction: "Extra dal", status: "Preparing" },
            { id: "#105", date: "26 Apr", customer: "Priya", meal: "Lunch", qty: 8, amt: 1200, address: "Andheri", phone: "5555555555", instruction: "", status: "Order Placed" },
            ],
        },
        {
            slot: "19-20",
            items: [
            { id: "#106", date: "26 Apr", customer: "Kiran", meal: "Dinner", qty: 15, amt: 2250, address: "Powai", phone: "4444444444", instruction: "Spicy", status: "Order Placed" },
            ],
        },
    ];

    const ALL_ORDERS = [
  {
    id: "#101",
    date: "26 Apr",
    slot: "06-07",
    meal: "Breakfast",
    status: "Delivered",
    qty: 10,
    amount: 1200,

    customer: {
      name: "Sanjeev",
      address: "Colaba",
      phone: "9999999999",
    },

    kitchen: {
      name: "Kitchen A",
      code: "FP101",
      address: "Colaba",
      phone: "8888888888",
    },

    delivery: {
      name: "FastExpress",
      code: "DLV101",
      address: "Mumbai",
      phone: "7777777777",
    },

    ratings: {
      food: 4.5,
      delivery: 4.0,
    },

    remarks: {
      customer: "Good food",
      kitchen: "Prepared fresh",
      delivery: "On time",
    },
  },

  {
    id: "#102",
    date: "26 Apr",
    slot: "12-13",
    meal: "Lunch",
    status: "Preparing",
    qty: 8,
    amount: 1200,

    customer: {
      name: "Rahul",
      address: "Andheri",
      phone: "6666666666",
    },

    kitchen: {
      name: "Kitchen B",
      code: "FP102",
      address: "Andheri",
      phone: "5555555555",
    },

    delivery: {
      name: "QuickMove",
      code: "DLV102",
      address: "Mumbai",
      phone: "4444444444",
    },

    ratings: {
      food: null,
      delivery: null,
    },

    remarks: {
      customer: "",
      kitchen: "",
      delivery: "",
    },
  },

  {
    id: "#103",
    date: "25 Apr",
    slot: "19-20",
    meal: "Dinner",
    status: "Delivered",
    qty: 15,
    amount: 2250,

    customer: {
      name: "Neha",
      address: "Bandra",
      phone: "3333333333",
    },

    kitchen: {
      name: "Kitchen C",
      code: "FP103",
      address: "Bandra",
      phone: "2222222222",
    },

    delivery: {
      name: "SpeedGo",
      code: "DLV103",
      address: "Mumbai",
      phone: "1111111111",
    },

    ratings: {
      food: 5,
      delivery: 4.5,
    },

    remarks: {
      customer: "Excellent",
      kitchen: "Handled well",
      delivery: "Smooth delivery",
    },
  },
];

  return (
    <div className="p-2 text-sm space-y-3 text-white [&_p]:text-white">
      <h1 className="text-center font-bold text-lg">🍽️ MealFlow24</h1>

      <div className="grid grid-cols-4 gap-1">
        {Tab("customer", "Customer")}
        {Tab("kitchen", "Kitchen")}
        {Tab("orders", "My Orders")}
        {Tab("delivery", "Delivery")}
      </div>

      {/* ================= CUSTOMER ================= */}
      {tab === "customer" && (
        <div className="space-y-2 text-black">
          <button className="w-32 lg:w-40 text-xs lg:text-sm bg-blue-500 text-white p-2">Load Preferences</button>

          <input className="w-full p-2 border" defaultValue="421204" />

          <select className="w-full p-2 border h-12">
            {["Casa-Bella","Casa-Bella Gold","Casa-Rio","Desai Shati Nagar","Desal","Khidkali","Khoni","Lakeshore", "Lodha Heaven","Manpada","Nulje","Padle","Riverwood Park"].map(n=><option key={n}>{n}</option>)}
          </select>

          <div className="bg-blue-500 p-2 rounded">
            <b className="text-yellow-200">Recommended Kitchens</b>
            <p className="text-xs lg:text-sm">Kitchen A ⭐4.5 ₹110</p>
            <p className="text-xs lg:text-sm">Kitchen B ⭐4.2 ₹120</p>
          </div>

          <div className="flex gap-1">
            <input className="flex-1 p-2 border" placeholder="Food Provider Code" />
            <button disabled={fpVerified} onClick={()=>setFpVerified(true)} className="w-10 lg:w-12 text-xs lg:text-sm bg-green-500 text-white p-2">
              <FontAwesomeIcon icon={faStar} />
            </button>
          </div>

          {fpVerified && (
            <div className="text-xs bg-gray-600 p-2">
              Kitchen A | Colaba | 9999999999
            </div>
          )}

          <select className="w-full h-12 p-2 border">
            {Array.from({length:24},(_,i)=><option key={i}>{i.toString().padStart(2,'0')}-{(i+1)%24}</option>)}
          </select>

          <input type="date" className="w-full p-2 border" />
          <input type="date" className="w-full p-2 border" />

          <select className="w-full h-12 p-2 border">
            <option>Breakfast</option><option>Lunch</option><option>Dinner</option><option>Evening Snacks</option>
          </select>

          <select className="w-full h-12 p-2 border"><option>Veg</option><option>Non-Veg</option></select>

          <input className="w-full h-12 p-2 border" placeholder="Target Price" />
          <textarea
            className="p-2 border text-white"
            style={{ height: "200px" }}
            placeholder="Items"
          />          
          <input className="w-full p-2 border" placeholder="Quantity" />

          <select onChange={(e)=>setPacking(e.target.value)} className="w-full h-12 p-2 border">
            <option value="casserole">Casserole</option>
            <option value="disposable">Disposable</option>
          </select>

          {packing === "casserole" && (
            <select className="w-full h-12 p-2 border">
              <option>Kitchen Provides</option>
              <option>Customer Provides</option>
            </select>
          )}

          {packing === "disposable" && (
            <input className="w-full p-2 border" placeholder="Packaging Cost" />
          )}

          <select onChange={(e)=>setDeliveryMode(e.target.value)} className="w-full h-12 p-2 border">
            <option value="home">Home Delivery</option>
            <option value="pickup">Customer Pickup</option>
            <option value="partner">Through Delivery Partner</option>
          </select>

          {deliveryMode === "partner" && (
            <input className="w-full p-2 border" placeholder="Delivery Charges" />
          )}

          <div className="bg-green-500 p-2">
            <b className="text-yellow-200">Recommended Delivery Providers</b>
            <p className="text-xs lg:text-sm">DLV101 FastExpress</p>
          </div>

          <div className="bg-orange-500 p-2">
            <b className="text-yellow-200">Available Delivery Providers</b>
            <p className="text-xs lg:text-sm">DLV102 QuickMove</p>
          </div>

          <div className="flex gap-1">
            <input className="flex-1 p-1 border w-80" placeholder="Delivery Provider Code" />
            <button disabled={dpVerified} onClick={()=>setDpVerified(true)} className="w-10 lg:w-12 text-xs lg:text-sm bg-green-500 text-white p-2">
              <FontAwesomeIcon icon={faCheck} />
            </button>
          </div>

          {dpVerified && (
            <div className="text-xs bg-gray-100 p-2">
              FastExpress | Mumbai | 8888888888
            </div>
          )}
          <textarea
            className="p-2 border text-white"
            style={{ height: "200px" }}
            placeholder="Input Instructions"
          />  

          <button className="w-32 lg:w-40 text-xs lg:text-sm bg-gray-500 text-white p-2">Save Preference</button>
          <button className="w-32 lg:w-40 text-xs lg:text-sm bg-green-600 text-white p-2">Place Order</button>
        </div>
      )}

      {/* ================= KITCHEN ================= */}
      {tab === "kitchen" && (
        <div className="space-y-2 bg-gray-800 text-white">
          <div className="p-2 border space-y-3">
            <b>Incoming Orders</b>

            {ordersData.map((slot, idx) => {
                const mealCount = slot.items.reduce((acc, o) => {
                acc[o.meal] = (acc[o.meal] || 0) + 1;
                return acc;
                }, {});

                return (
                <div key={idx} className="border rounded p-2">
                    {/* Slot Header */}
                    <div className="flex justify-between text-xs font-semibold mb-1">
                    <span className="text-yellow-200">⏰ Slot {slot.slot}</span>
                    <span>
                        {Object.entries(mealCount).map(([meal, count]) => (
                        <span key={meal} className="mr-2 text-gray-100">{meal}: {count}</span>
                        ))}
                    </span>
                    </div>

                    {/* Orders List */}
                    {slot.items.map((order) => (
                    <div
                        key={order.id}
                        onClick={() => setSelectedOrder(order)}
                        className="border p-2 mb-2 rounded cursor-pointer bg-gray-800 text-xs"
                    >
                        <div className="flex justify-between">
                        <span className="text-gray-100"><b>{order.id}</b></span>
                        <span className="text-gray-100">{order.qty} Qty</span>
                        </div>
                        <div className="flex justify-between text-gray-600">
                        <span className="text-gray-100">{order.meal}</span>
                        <span className="text-gray-100">₹ {order.amt}</span>
                        </div>
                    </div>
                    ))}

                    <button className="w-48 lg:w-64 text-xs lg:text-sm bg-green-500 text-white p-1 rounded">
                    Accept Slot Batch
                    </button>
                </div>
                );
            })}
          </div>

          {selectedOrder && (
            <div className="p-3 border bg-gray-700 text-white [&_p]:text-white mt-3 text-xs space-y-1">
                <b className="text-sm lg:text-lg">Order Detail</b>

                <p>Order#: {selectedOrder.id}</p>
                <p>Date: {selectedOrder.date}</p>
                <p>Slot: {selectedOrder.slot || "-"}</p>

                <p>Customer: {selectedOrder.customer}</p>
                <p>Address: {selectedOrder.address}</p>
                <p>Contact: {selectedOrder.phone}</p>

                <p>Meal: {selectedOrder.meal}</p>
                <p>Qty: {selectedOrder.qty}</p>
                <p>Amount: ₹ {selectedOrder.amt}</p>

                <p>Instruction: {selectedOrder.instruction || "NA"}</p>

                {/* Status Flow */}
                <div>
                <label>Status</label>
                <select className="w-full border p-1">
                    <option>Order Placed</option>
                    <option>Preparing</option>
                    <option>Delivered</option>
                </select>
                </div>

                <textarea
                    className="p-2 border text-white"
                    style={{ height: "200px" }}
                    placeholder="My Remarks"
                />  

                <button className="w-24 lg:w-32 tetx-xs lg:text-sm bg-blue-500 text-white p-1 rounded">
                Update
                </button>
            </div>
          )}

          <div className="p-2 border">
            <b>Batch Cooking Plan</b>
            <Bar data={chartData} options={options} />
          </div>
        </div>
      )}

      {/* ================= MY ORDERS ================= */}
      {tab === "orders" && (
        <div className="space-y-2 text-white min-h-[100vh]">
          <select className="w-full h-12 p-2 border bg-black" onChange={(e)=>setRole(e.target.value)}>
            <option value="customer">Customer</option>
            <option value="prep">Food Preparator</option>
            <option value="delivery">Delivery Partner</option>
          </select>

          {role === "customer" && ALL_ORDERS.map((o) => (
                <div key={o.id} className="p-2 border bg-gray-800 text-white">
                <div className="flex justify-between text-xs font-semibold">
                    <span className="text-gary-100">{o.id}</span>
                    <span className="text-gary-100">{o.status}</span>
                </div>

                <div className="text-xs">
                    {o.date} | {o.slot} | {o.meal}
                </div>

                <p className="text-xs">Kitchen: {o.kitchen.name}</p>

                {o.status === "Delivered" && (
                    <div className="space-y-2">
                    <StarRating value={o.ratings.food || 0} onChange={() => {}} />
                    <StarRating value={o.ratings.delivery || 0} onChange={() => {}} />
                    </div>
                )}

                <textarea
                    className="w-full border mt-2 text-xs"
                    style={{ height: "200px" }}
                    placeholder="My Remarks"
                />
                </div>
            ))}
            
            {role === "prep" && ALL_ORDERS.map((o) => (
                <div key={o.id} className="p-2 border bg-gray-800">
                <div className="flex justify-between text-xs font-semibold">
                    <span>{o.id}</span>
                    <span>{o.status}</span>
                </div>

                <div className="text-xs">
                    {o.date} | {o.slot} | {o.meal}
                </div>

                <p className="text-xs">
                    Customer: {o.customer.name} ({o.customer.phone})
                </p>

                <select className="w-full border text-xs mt-1">
                    <option>Pending</option>
                    <option>Preparing</option>
                    <option>Delivered</option>
                </select>

                <textarea
                    className="w-full border mt-2 text-xs"
                    style={{height: "200px"}}
                    placeholder="My Remarks"
                />
                </div>
            ))}

            {role === "delivery" && ALL_ORDERS.map((o) => (
                <div key={o.id} className="p-2 border bg-gray-800">
                <div className="flex justify-between text-xs font-semibold">
                    <span>{o.id}</span>
                    <span>{o.meal}</span>
                </div>

                <div className="text-xs">
                    {o.date} | {o.slot}
                </div>

                <p className="text-xs">
                    {o.kitchen.name} → {o.customer.name}
                </p>

                {o.status === "Delivered" && (
                    <StarRating value={o.ratings.delivery || 0} onChange={() => {}} />
                )}
                </div>
            ))}
        </div>
      )}

      {/* ================= DELIVERY ================= */}
      {tab === "delivery" && (
        <div className="space-y-3">
            <b className="block">Batch Jobs</b>

            {deliveryData.map((slotData, index) => (
                <div key={index} className="border rounded p-2">
                    <div className="font-semibold text-sm mb-1">
                    ⏰ Slot: {slotData.slot}
                    </div>

                    {slotData.jobs.map((job) => (
                    <div
                        key={job.id}
                        className="border p-2 mb-2 rounded cursor-pointer bg-gray-700"
                        onClick={() => alert(`Viewing ${job.id}`)}
                    >
                        <div className="flex justify-between text-xs">
                        <span><b>{job.kitchen}</b></span>
                        <span>{job.orders} Orders</span>
                        </div>

                        {/* DETAIL (can convert to modal later) */}
                        <div className="mt-2 text-xs bg-gray-700 p-2 rounded">
                        <p><b>Pickup From:</b></p>
                        <p>{job.kitchen}, Colaba</p>
                        <p>📞 9999999999</p>

                        <p className="mt-1"><b>Deliver To:</b></p>
                        <p>Customer: Sanjeev</p>
                        <p>Address: Colaba, Mumbai</p>
                        <p>📞 8888888888</p>

                        <p className="mt-1 text-green-600"><b>Status:</b> Pickup</p>
                        </div>
                    </div>
                    ))}

                    <button className="w-32 lg:w-40 text-xs lg:text-sm bg-green-500 text-white p-1 rounded">
                        Accept Slot Batch
                    </button>
                </div>
            ))}
        </div>
        )}
    </div>
  );
}
